import React from 'react';

import { CustomRoute } from 'util/hook/useRouter';
import { appPath } from 'util/routingConfig';

import EventsFeaturedRidesInfoRoute from './Info';

const routes: CustomRoute = {
	path: appPath.eventsFeaturedRides.replace(appPath.events, ''),
	components: () => [],
	render: (_, children) => children,
	children: [
		{
			path: '',
			components: () => [import(/* webpackChunkName: 'eventsFeaturedRides' */ './component')],
			render: ([EventsFeaturedRides]) => <EventsFeaturedRides />,
		},
		EventsFeaturedRidesInfoRoute,
	],
};

export default routes;
